import {Component, OnInit} from '@angular/core';

import {CamposValidator} from '@app/validators/campos.validator';

import estadoCivil from '@assets/json/estado-civil.json';
import genero from '@assets/json/genero.json';
import layout from '@assets/json/layout.json';
import uf from '@assets/json/uf.json';
import {ModalService} from '@app/shared/services/modal.service';
import {AppUtil} from '@app/utils/app.util';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CpfValidator} from '@app/validators/cpf.validator';
import {PisValidator} from '@app/validators/pis.validator';
import {Cidade, EditarDadosCandidatoCommand} from '@app/models/sisrh.model';
import {SisrhService} from '@app/services/sisrh.service';
import {AutenticacaoService} from '@app/services/autenticacao.service';
import {Router} from '@angular/router';

@Component({
  templateUrl: './editar-dados.page.html',
  styleUrls: ['./editar-dados.page.css']
})
export class EditarDadosPage implements OnInit {

  formulario: FormGroup;
  layout = layout.editarDadosPage;

  mascaraCpf = AppUtil.mascararCpf();
  mascaraCep = AppUtil.mascararCep();
  mascaraTelefone = AppUtil.mascararTelefone();
  mascaraPis = AppUtil.mascararPis();

  idGeneroMasculino = genero.idGeneroMasculino;
  idGeneroFeminino = genero.idGeneroFeminino;
  listaUf = uf;
  cidades: Cidade[];
  listaEstadoCivil = estadoCivil;

  constructor(
    private formBuilder: FormBuilder,
    private service: SisrhService,
    private autenticacaoService: AutenticacaoService,
    private modalService: ModalService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.configurarFormulario();
    this.configurarEventosDoFormulario();
    this.carregarDados();
  }

  private configurarFormulario() {
    this.formulario = this.formBuilder.group({
      cpf: ['', [CpfValidator.cpfInvalido, Validators.required]],
      nome: ['', [Validators.required]],
      pis: ['', [PisValidator.pisLengthValidator]],
      idGenero: ['', [Validators.required]],
      dataNascimento: ['', [Validators.required]],
      rg: ['', [Validators.required]],
      orgaoEmissorRG: ['', [Validators.required]],
      ufEmissorRG: ['', [Validators.required]],
      idEstadoCivil: ['', [Validators.required]],
      nomeMae: ['', [Validators.required]],
      cep: ['', [Validators.required]],
      uf: ['', [Validators.required]],
      cidade: ['', [Validators.required]],
      bairro: ['', [Validators.required]],
      logradouro: ['', [Validators.required]],
      numero: ['', [Validators.required]],
      complemento: '',
      telefone: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      confirmarEmail: ['', [Validators.required, Validators.email]],
    }, {
      validator: [
        CamposValidator.iguais('email', 'confirmarEmail'),
      ]
    });


  }

  private configurarEventosDoFormulario() {
    this.formulario.get('uf').valueChanges.subscribe(uf => {
      if (uf) {
        this.service.BuscarCidadesPorUf(uf).subscribe(data => {
          this.cidades = data;
        });
      } else {
        this.formulario.get('cidade').reset();
      }
    });
  }

  private carregarDados() {
    this.formulario.disable();
    this.service.BuscarDadosCandidato(
      this.autenticacaoService.getValorUsuarioAtualCandidato.cpf,
      this.autenticacaoService.getTokenCandidato()).subscribe(data => {
        //console.log(data);
        this.formulario.patchValue({
          cpf: data.cpf,
          nome: data.nome,
          idGenero: data.genero ? data.genero === 'Masculino' ? this.idGeneroMasculino : this.idGeneroFeminino : null,
          dataNascimento: data.dataNascimento ? data.dataNascimento.split('T')[0] : null,
          rg: data.rg,
          orgaoEmissorRG: data.orgaoEmissorRG,
          ufEmissorRG: data.ufEmissorRG,
          pis: data.pis,
          idEstadoCivil: data.estadoCivil ? this.listaEstadoCivil.find(e => e.nome === data.estadoCivil).idEstadoCivil : null,
          nomeMae: data.nomeMae,
          cep: data.cep,
          uf: data.uf,
          cidade: data.cidade,
          bairro: data.bairro,
          logradouro: data.logradouro,
          numero: data.numero,
          complemento: data.complemento,
          telefone: data.telefone ? this.apenasNumeros(data.telefone) : null,
          email: data.email,
          confirmarEmail: data.email
        });
    }, error => {
        console.error(error);
    }, () => {
        this.formulario.enable();
        this.formulario.get('cpf').disable();
    });
  }

  enviarFormulario() {
    const command: EditarDadosCandidatoCommand = {
      idCandidato: this.autenticacaoService.getValorUsuarioAtualCandidato.idCandidato,
      nome: this.formulario.get('nome').value,
      idGenero: this.formulario.get('idGenero').value,
      dataNascimento: new Date(this.formulario.get('dataNascimento').value + 'T00:00').toISOString(),
      rg: this.formulario.get('rg').value,
      orgaoEmissorRG: this.formulario.get('orgaoEmissorRG').value,
      ufEmissorRG: this.formulario.get('ufEmissorRG').value,
      pis: this.formulario.get('pis').value,
      idEstadoCivil: this.formulario.get('idEstadoCivil').value,
      nomeMae: this.formulario.get('nomeMae').value,
      cep: this.formulario.get('cep').value,
      uf: this.formulario.get('uf').value,
      cidade: this.formulario.get('cidade').value,
      bairro: this.formulario.get('bairro').value,
      logradouro: this.formulario.get('logradouro').value,
      numero: this.formulario.get('numero').value,
      complemento: this.formulario.get('complemento').value,
      telefone: this.apenasNumeros(this.formulario.get('telefone').value),
      email: this.formulario.get('email').value
    };

    this.service.editar(command,
      this.autenticacaoService.getTokenCandidato()).subscribe(data => {
      if (data.success) {
        this.modalService
          .alert('s', 'Sucesso', data.message)
          .subscribe(() => this.router.navigate(['/vagas/lista']));
      } else {
        this.modalService
          .alert('a', 'Atenção', 'Não foi possível editar o cadastro.')
          .subscribe();
      }
    });
  }

  mostrarModalCancelar() {
    this.modalService.confirm('a', 'Atenção', 'Deseja Cancelar?').subscribe(r => {
      if (r === true) {
        this.router.navigate(['/vagas/lista']);
      }
    });
  }

  apenasNumeros(valor: string): string {
    return valor.replace(/\D/g, '');
  }
}
